import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
	type = 'primary',
	label,
	onClick,
	classes = '',
	isDisabled = false,
	isHidden = false,
	isInline = false,
}) => (
	<button
		type="button"
		className={`button is-${type} ${isInline && 'is-inline'} ${classes}`}
		disabled={isDisabled}
		onClick={onClick}
		hidden={isHidden}
	>
		{label}
	</button>
);

export default Button;

Button.propTypes = {
	type: PropTypes.string,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	classes: PropTypes.string,
	isDisabled: PropTypes.bool,
	isHidden: PropTypes.bool,
	isInline: PropTypes.bool,
};
